<div class="cake-info-tabs font-md">
  <div class="cake-info-tab border-primary"
       *ngIf="isDescriptionTabAvailable"
       [class.active]="activeTab===TABS.ABOUT_PRODUCT"
       [translate]="'cakeBuilder.productInfo.aboutProduct'"
       (click)="activeTab=TABS.ABOUT_PRODUCT">Om produktet
  </div>

  <div class="cake-info-tab border-primary"
       *ngIf="isIngredientsTabAvailable"
       [class.active]="activeTab===TABS.INGREDIENTS"
       [translate]="'cakeBuilder.productInfo.ingredients'"
       (click)="activeTab=TABS.INGREDIENTS">Ingredienser
  </div>

  <div class="cake-info-tab border-primary"
       *ngIf="isDeadlineTabAvailable"
       [class.active]="activeTab===TABS.DEADLINE"
       [translate]="'cakeBuilder.productInfo.orderDeadlines'"
       (click)="activeTab=TABS.DEADLINE">Bestillingsfrist
  </div>

  <div class="tab-gap d-md-none"></div>
</div>

<div class="cake-info-tab-content pt-2 mb-4 font-md"
     *ngIf="activeTab===TABS.ABOUT_PRODUCT">

  <div class="mb-2" *ngIf="hasDiscount">{{ discountStr }}</div>

  <product-sold-out-dates-info *ngIf="hasDailyLimitSoldOutDates"
                               class="d-block mb-2"
                               [productType]="cake"
  ></product-sold-out-dates-info>

  <product-availability-info
    [availability]="cake?.availability"
    [cssClass]="'mb-2'"
  ></product-availability-info>

  <div *ngIf="cake?.sameDayDeliverySettings?.isAvailableForSameDayDelivery &&
              cake?.sameDayDeliverySettings?.showDescription">
    {{ cake.sameDayDeliverySettings.description }}
  </div>

  <div class="cake-info-description wysiwyg" [innerHTML]="cake.description"></div>
</div>

<div class="cake-info-tab-content pt-2 mb-4 font-md"
     *ngIf="activeTab===TABS.INGREDIENTS">

  <div *ngIf="containsMightFreeAllergens">
    <span
      [translate]="'cakeBuilder.allergensStateLabels.contains'"></span>: {{ containsMightFreeAllergens }}
  </div>

  <div *ngIf="mightFreeAllergens">
    <span [translate]="'cakeBuilder.allergensStateLabels.canBeMadeWithout'"></span>: {{ mightFreeAllergens }}
  </div>

  <div class="mt-3 ingredients"
       [innerHTML]="ingredients">
  </div>
</div>

<div class="cake-info-tab-content pt-2 mb-4"
     *ngIf="activeTab===TABS.DEADLINE">
  <div *ngIf="sameDayDeadlineMessage; else orderDeadlinesInfo" class="font-md">
    {{ sameDayDeadlineMessage }}
  </div>

  <ng-template #orderDeadlinesInfo>
    <ui-deadlines-info class="font-md" [deadlines]="orderDeadlines"></ui-deadlines-info>
  </ng-template>

  <div class="mt-3 font-md"
       *ngIf="cake.mailDeliveryAvailable"
       [translate]="'cakeBuilder.productInfo.deadlineSentByMailMessage'">
    Deadlines does not apply for products being sent by mail
  </div>

  <div class="mt-3 font-md" *ngIf="specialDeadlines && specialDeadlines.length">
    <div [translate]="'cakeBuilder.specialDeadlines.title'">Special deadlines</div>

    <div *ngFor="let deadline of specialDeadlines">
      {{
        'cakeBuilder.specialDeadlines.info' | translate: {
          orderDate: deadline.orderDate,
          beforeTime: deadline.beforeTime,
          beforeDate: deadline.beforeDate
        }
      }}
    </div>
  </div>
</div>
